module.exports = __webpack_public_path__ + "img/beaker-teal.e0847861.png";